<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div class="card-head box-shadow bg-white p-15 p-sm-20 p-md-25 radius-7">
      <h5 class="mb-15">Subcategorias de serviços</h5>
      <form class="row g-3 align-items-end" @submit.prevent="save">
        <div class="col-md-4">
          <label class="form-label">Categoria</label>
          <select v-model="form.category_id" class="form-select" required>
            <option disabled value="">Selecione a categoria</option>
            <option v-for="category in getCategories" :key="category.id" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label">Subcategoria</label>
          <input v-model.trim="form.name" class="form-control" placeholder="Ex.: Protocolos faciais" required />
        </div>
        <div class="col-md-2">
          <label class="form-label">Ordem</label>
          <input v-model.number="form.sort" type="number" min="0" class="form-control" />
        </div>
        <div class="col-md-2 d-flex gap-2">
          <button class="btn btn-success flex-grow-1" :disabled="saving">
            {{ saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Criar') }}
          </button>
          <button v-if="editingId" type="button" class="btn btn-outline-secondary" @click="resetForm">Cancelar</button>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input id="subcategory-active" v-model="form.active" type="checkbox" class="form-check-input" />
            <label for="subcategory-active" class="form-check-label">Subcategoria ativa</label>
          </div>
        </div>
      </form>
      <div v-if="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead><tr><th>Subcategoria</th><th>Categoria</th><th>Ordem</th><th>Status</th><th class="text-end">Editar</th></tr></thead>
          <tbody>
            <tr v-for="subcategory in getSubcategories" :key="subcategory.id">
              <td>{{ subcategory.name }}</td>
              <td>{{ subcategory.category?.name || '-' }}</td>
              <td>{{ subcategory.sort ?? '-' }}</td>
              <td>{{ subcategory.active ? 'Ativa' : 'Inativa' }}</td>
              <td class="text-end"><button class="btn btn-sm btn-outline-primary" @click="edit(subcategory)">Editar</button></td>
            </tr>
            <tr v-if="!getSubcategories.length"><td colspan="5" class="text-center text-muted">Nenhuma subcategoria cadastrada.</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default defineComponent({
  name: 'SubcategoriesList',
  data() {
    return {
      editingId: null as number | null,
      saving: false,
      error: '',
      form: { category_id: '' as string | number, name: '', sort: null as number | null, active: true },
    };
  },
  computed: mapGetters(['getCategories', 'getSubcategories']),
  mounted() { this.fetchSubcategories(); },
  methods: {
    ...mapActions(['fetchSubcategories']),
    edit(subcategory: any) {
      this.editingId = subcategory.id;
      this.form = { category_id: subcategory.category_id, name: subcategory.name, sort: subcategory.sort, active: !!subcategory.active };
    },
    resetForm() {
      this.editingId = null;
      this.form = { category_id: '', name: '', sort: null, active: true };
      this.error = '';
    },
    async save() {
      this.saving = true;
      this.error = '';
      const payload = { ...this.form, category_id: Number(this.form.category_id) };
      try {
        if (this.editingId) await api.axios.put(`/api/subcategory/update/${this.editingId}`, payload);
        else await api.axios.post('/api/subcategory/create', payload);
        await this.fetchSubcategories();
        this.resetForm();
      } catch (error: any) {
        this.error = error?.response?.data?.message || 'Não foi possível salvar a subcategoria.';
      } finally {
        this.saving = false;
      }
    },
  },
});
</script>
